import { useMemo } from 'react';

import type { CuratePulseTrackingCustomProperties } from '../../../core/utils/types.js';
import type { ByfunnFront } from '../../types/frapi-types.js';

const usePersonalization = (
  response: ByfunnFront,
): CuratePulseTrackingCustomProperties => {
  const { id, context } = response.feed.properties;
  const { removeOnRead, removeOnImpressed, personalizedResults } =
    response.feed.personalization;

  const personalization: CuratePulseTrackingCustomProperties = useMemo(
    () => ({
      variant: id,
      context,
      removeOnRead,
      removeOnImpressed,
      personalizedResults,
    }),
    [id, context, removeOnRead, removeOnImpressed, personalizedResults],
  );

  return personalization;
};

export default usePersonalization;
